module.exports = __webpack_public_path__ + "static/media/landscape.48fe2ef8.svg";